import type { PropertyTier } from "@/Dashboard/pages/AssetLibrary/types";
import { PROPERTY_TIER_LEVEL } from "@/constants/property";
import type { Property } from "@/store/v2/currentProperty/selectors";
import type { Tier } from "@/store/v2/currentUser/selectors";

export const getTopLevelTier = (tiers?: Tier[]): string => {
  if (tiers) {
    return tiers?.reduce(
      (topTier, { title: currentTier }) =>
        PROPERTY_TIER_LEVEL[currentTier as PropertyTier] < PROPERTY_TIER_LEVEL[topTier as PropertyTier]
          ? topTier
          : currentTier,
      tiers[0].title,
    );
  }
  return "";
};

export const getPropertyMenuItems = (property: Property) => {
  return {
    propertyMenuItems: property.propertyMenuItems,
  };
};
